import React, { useRef } from 'react';
import classes from './CheckBox.module.scss';

const CheckBox = props => {
  const ref = useRef();
  return (
    <label
      className={classes.checkBox}
      tabIndex="0"
      onKeyPress={event => {
        if (event.key === 'Enter' && ref && ref.current) {
          ref.current.click();
        }
      }}
    >
      <div className={classes.row}>
        <div className={`${classes.column} ${classes.left} ${classes.checkBoxContainer}`}>
          <input
            ref={ref}
            name={props.name}
            type="checkbox"
            value={props.value}
            checked={props.checked}
            onChange={e => props.onChange(e, props.value)}
          />

          <div className={`${classes.markContainer}`}>
            <span className={`${classes.mark}`}></span>
          </div>
        </div>
        {props.icon ? (
          <div className={`${classes.column} ${classes.middle}`}>
            {props.icon && <img src={props.icon} className={classes.icon} alt=""></img>}
          </div>
        ) : null}
        {props.label ? (
          <div className={`${classes.column} ${classes.right}`}>
            {props.label.map((value, index) => (
              <span key={index}>{value}</span>
            ))}
          </div>
        ) : null}
      </div>
    </label>
  );
};

export default CheckBox;
